import { useSession } from "@clerk/clerk-react";
import {
  // Chip,
  // Switch, - replaced with HTML
  // Table,
  // TableBody,
  // TableCell,
  // TableColumn,
  // TableHeader,
  // TableRow,
  // Tooltip,
} from "@heroui/react";
import {
  AlertInfo,
  // Checkmark,
  // Document,
  // Lock,
  New,
  Plus,
  QRCode,
  //User,
} from "assets/icons";
import ButtonNew from "components/buttonNew/buttonNew";
import {
  EditableSelectComponent,
  EditableTextareaComponent,
  SectionHeader,
} from "components/index";

import { RenderSectionComponent } from "components/sections/renderSectionComponent";
import { useStableFieldsConfig } from "components/sections/configStabilizer";
import { API_URL } from "constants/index";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { useResources } from "shared/contexts/resources.context";
import {
  UnitDTO,
  UnitSubtype,
  UnitType,
} from "shared/types/unit";

import { createPatchObject } from "shared/utils/patch";
import ImprovedTimeslotManager from "screens/buildings/components/rentalTab/calendar/improvedTimeslotManager";
import {
  Eye,
  PencilSimple,
} from "@phosphor-icons/react";
import { UnitCommercialInfoComponent } from "shared/components/unit/UnitCommercialInfoComponent";
import { PublishCalendarModal } from "components/modals/PublishCalendarModal";
import { PlannedVisitsWarningModal } from "shared/components/rental/components/PlannedVisitsWarningModal";
import { usePlannedVisitsCheck } from "shared/components/rental/hooks/usePlannedVisitsCheck";
import type { CandidateInfo } from "components/candidates/types";
import { BuildingAssetsTab } from "screens/buildings/components/buildingAssetsTab/buildingAssetsTab";
import { useCanEditUnitIds } from "hooks/usePermissions";
import { ChangeUnitIdModal } from "./components/ChangeUnitIdModal";
import { ChangeLogViewer, UnitIdChangeLog } from "./components/ChangeLogViewer";

import { CustomFieldsSection } from "shared/components/customFields";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "components/ui/tabs";
import { Badge } from "components/ui/badge";
import { Button } from "components/ui/button";
import {
  ImageSquare,
  FileText,
  ArrowSquareOut,
  ArrowLeft,
} from "@phosphor-icons/react";
import { UnitRentalTab } from "./tabs/UnitRentalTab";
import { UnitCommercialPicturesGrid } from "./tabs/UnitCommercialPicturesGrid";
export type UnitInformationProps = {
  fetchUnits?: any;
};
function roundUpValue(value: any) {
  if (value === null || value === undefined) return value;
  // Replace commas with dots and parse to float
  let parsedValue = parseFloat(value.toString().replace(",", "."));
  // Ensure the value is not NaN
  if (isNaN(parsedValue)) {
    throw new Error("Invalid input for monetary value");
  }
  // Round up and return as integer
  return Math.ceil(parsedValue);
}
export const UnitInformation = ({ fetchUnits }: UnitInformationProps) => {
  const [editMode, setEditMode] = useState<boolean>(false);
  const { buildingId } = useParams();
  const [editedUnit, setEditedUnit] = useState<UnitDTO | null | undefined>(
    null,
  );
  const { session } = useSession();
  const { unitId } = useParams();
  const [unit, setUnit] = useState<UnitDTO | null | undefined>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { refreshResources } = useResources();
  const navigate = useNavigate();
  const [isPublishModalOpen, setIsPublishModalOpen] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>("overzicht");

  // Waarschuwing bij offline halen: kandidaten met een bezoek dat nog moet volgen
  const { check: checkPlannedVisits } = usePlannedVisitsCheck();
  const [plannedVisitsForUnpublish, setPlannedVisitsForUnpublish] = useState<CandidateInfo[] | null>(null);

  // Change Unit ID state
  const canEditUnitIds = useCanEditUnitIds();
  const [isChangeIdModalOpen, setIsChangeIdModalOpen] = useState<boolean>(false);
  const [isChangingId, setIsChangingId] = useState<boolean>(false);
  const [changeLog, setChangeLog] = useState<UnitIdChangeLog | null>(null);
  const [isChangeLogViewerOpen, setIsChangeLogViewerOpen] = useState<boolean>(false);

  // Debouncing timeout refs (removed - now handled in UnitCommercialInfoComponent)

  useEffect(() => {
    const fetchUnitData = async () => {
      try {
        const response = await fetchWithAuth(
          `${API_URL}/units/${unitId}`,
          { method: "GET" },
          session,
        );
        const data = await response.json();
        setUnit({
          ...data,
          buildingId: data.building.id,
          inspectionNumToilets: data.unitInspectionInfo?.numToilets,
          inspectionNumBathrooms: data.unitInspectionInfo?.numBathrooms,
          inspectionNumBedrooms: data.unitInspectionInfo?.numBedrooms,
          inspectionGeneralRemarks: data.unitInspectionInfo?.generalRemarks,
          unitMaxCapacityPersons:
            data.unitConformityInfo?.unitMaxCapacityPersons,
        });
        setEditedUnit({
          ...data,
          buildingId: data.building.id,
          inspectionNumToilets: data.unitInspectionInfo?.numToilets,
          inspectionNumBathrooms: data.unitInspectionInfo?.numBathrooms,
          inspectionNumBedrooms: data.unitInspectionInfo?.numBedrooms,
          inspectionGeneralRemarks: data.unitInspectionInfo?.generalRemarks,
          unitMaxCapacityPersons:
            data.unitConformityInfo?.unitMaxCapacityPersons,
        });
        setEditMode(false);
        setIsLoading(false);
      } catch (error) {
        console.error("Failed to fetch unit data", error);
        // Handle error appropriately
      }
    };

    fetchUnitData();
  }, [unitId]);

  useEffect(() => {
    if (!buildingId) {
      setIsLoading(false);
      // No ID => Creating a new unit
      setUnit({
        id: "",
        buildingId: buildingId,
      });
      setEditedUnit({
        id: "",
        buildingId: buildingId,
      });
    }
  }, [buildingId]);

  const isValidUnit = (unit: UnitDTO) => {
    console.log(unit);
    //  When creating a unit these fields should be at least present
    return true;
  };

  // const handleElectricityInfoChange = (value: any) => {
  //   setEditedUnit((prev: any) => ({
  //     ...prev,
  //     electricityInfo: { ...prev.electricityInfo, ...value },
  //   }));
  // };

  useEffect(() => {
    // Listener for Escape key to exit edit mode
    const handleKeydown = (e: KeyboardEvent) => {
      if (editMode && e.key === "Escape") {
        setEditedUnit(unit);
        toggleEditMode();
      }
    };

    document.addEventListener("keydown", handleKeydown);
    return () => {
      // Cleanup event listener
      document.removeEventListener("keydown", handleKeydown);
    };
  }, [unit, editMode]);

  // Cleanup timeouts on component unmount (removed - now handled in UnitCommercialInfoComponent)

  const saveUnitUpdates = async () => {
    if (!editedUnit || !isValidUnit(editedUnit)) {
      toast.error("Er ontbreken verplichte velden.");
      return;
    }

    const updatedUnit = {
      ...editedUnit,
      advertisedRentalPrice: roundUpValue(editedUnit.advertisedRentalPrice),
      advertisedProvisions: roundUpValue(editedUnit.advertisedProvisions),
      estimatedRentalValue: roundUpValue(editedUnit.estimatedRentalValue),
      estimatedCommonCosts: roundUpValue(editedUnit.estimatedCommonCosts),
      estimatedPropertyTax: roundUpValue(editedUnit.estimatedPropertyTax),
      // ... other properties of editedUnit ...
      availableFrom: editedUnit.availableFrom,
    };

    const patchObject = createPatchObject(unit, updatedUnit);

    if (Object.keys(patchObject).length === 0) {
      toast("No changes detected!");
      return;
    }

    try {
      if (unit?.id) {
        // Updating an existing unit
        await fetchWithAuth(
          `${API_URL}/units/update/${unit?.id}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(patchObject),
          },
          session,
        );
        // Update the unit state with the new values after successful save
        setUnit(updatedUnit);
        if (fetchUnits) fetchUnits();
        toast("Unit geupdate!");
      } else {
        // Creating a new unit
        const response = await fetchWithAuth(
          `${API_URL}/units/create`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(editedUnit),
          },
          session,
        );
        const newUnitData = await response.json();
        // Update the unit data with the new data
        if (newUnitData && newUnitData.id) {
          setUnit({ ...newUnitData, buildingId: newUnitData.building.id });
          setEditedUnit({
            ...newUnitData,
            buildingId: newUnitData.building.id,
          });
        }
      }

      refreshResources();
    } catch (error) {
      console.error("Failed to save unit: ", error);
      toast("Error saving unit!");
    } finally {
      setEditMode(false);
      navigate(`/unit/detail/${unit?.id}`);
    }
  };

  const toggleEditMode = () => {
    setEditMode((prevMode) => !prevMode);
    if (!editMode) {
      setEditedUnit(unit);
    }
  };
  const unitTypeOptions = Object.values(UnitType).map((value) => ({
    value: value,
    label: value,
  }));
  const unitSubTypeOptions = Object.values(UnitSubtype).map((value) => ({
    value: value,
    label: value,
  }));

  const generalFieldsConfig = useStableFieldsConfig([
    { label: "Gebouwcode", key: "buildingId", disableEditMode: true },
    { label: "Unitcode", key: "id", disableEditMode: true },
    { label: "Odoo ID (= Kostenplaats)", key: "odooId" },
    {
      label: "Bus",
      key: "boxNumber",
      disableEditMode:
        unit?.id != null && unit?.id != undefined && unit?.id != "",
    },
    {
      label: "Referentie +",
      key: "referencePlus",
    },
    { label: "Unit custom address (optioneel)", key: "unitCustomAddress" },
    { label: "Verdieping", key: "floor" },
    {
      label: "Unit type",
      key: "unitType",
      Component: () => (
        <EditableSelectComponent
          label="Unit type"
          editMode={editMode}
          value={editedUnit?.unitType || unit?.unitType || ""}
          options={unitTypeOptions}
          onChange={(value: string) =>
            setEditedUnit((prev: any) => ({ ...prev, unitType: value }))
          }
        />
      ),
    },
    {
      label: "Unit subtype",
      key: "unitSubtype",
      Component: () => (
        <EditableSelectComponent
          label="Unit subtype"
          editMode={editMode}
          value={editedUnit?.unitSubtype || unit?.unitSubtype || ""}
          options={unitSubTypeOptions}
          onChange={(value: string) =>
            setEditedUnit((prev: any) => ({ ...prev, unitSubtype: value }))
          }
        />
      ),
    },
    {
      label: "Opleverdatum (eerste introductie binnen portefeuille)",
      key: "unitBuiltAt",
      Component: ({ editMode: fieldEditMode, value, onChange, isLoading: fieldLoading }: any) => {
        if (fieldLoading) return null;
        if (fieldEditMode) {
          return (
            <input
              type="date"
              value={value ? new Date(value).toISOString().split('T')[0] : ''}
              onChange={(e) => onChange(e.target.value || null)}
              className="px-3 py-2 rounded-sm border border-neutral-primary/20 bg-white text-neutral-primary text-sm"
            />
          );
        }
        return (
          <p className="font-medium">
            {value ? new Date(value).toLocaleDateString('nl-BE') : 'Niet ingevuld'}
          </p>
        );
      },
    },
    // Note: Commercial description has been moved to UnitCommercialInfoComponent
    {
      label: "Beschrijving van de indeling",
      key: "unitLayoutDescription",
      Component: EditableTextareaComponent,
    },
  ]);
  
  const unitKeyFigures = useStableFieldsConfig([
    {
      label: "Geschatte huurwaarde (ERV) / maand",
      key: "estimatedRentalValue",
      mask: "valuta",
    },
    {
      label: "Provisie Gemeenschappelijke kosten / maand",
      key: "estimatedCommonCosts",
      mask: "valuta",
    },
    {
      label: "Provisie OV / maand",
      key: "estimatedPropertyTax",
      mask: "valuta",
    },
    // Note: Surface fields have been moved to UnitCommercialInfoComponent
  ]);
  const utilitiesConfig = useStableFieldsConfig([
    // Note: Most utility fields have been moved to UnitCommercialInfoComponent
    { label: "Matterport", key: "matterportURL" },
    { label: "Interne faciliteiten (tags)", key: "internalFacilities" },
  ]);
  // Note: Inside fields have been moved to UnitCommercialInfoComponent
  const yallyStandardsFieldsConfig = useStableFieldsConfig([
    { label: "360 URL", key: "360URL" },
    { label: "Actueel EPC label", key: "currentEPCValue" },
    { label: "Toegangscode Wifi", key: "accessCodeWifi" },
    {
      label: "Huurportaal QR code",
      key: "rentalPortalQRCode",
      Component: () => (
        <EditableSelectComponent
          label="Unit type"
          editMode={editMode}
          value={editedUnit?.unitType || unit?.unitType || ""}
          options={unitTypeOptions}
          onChange={(value: string) =>
            setEditedUnit((prev: any) => ({ ...prev, unitType: value }))
          }
        />
      ),
    },
  ]);

  const sharedSectionProps = {
    editMode,
    isLoading,
    onEditClick: toggleEditMode,
    onSaveClick: saveUnitUpdates,
    editedState: editedUnit,
    originalState: unit,
    setStateFunction: setEditedUnit,
  };

  //const [isViewMaterialModalOpen, setIsViewMaterialModalOpen] = useState(false);
  //const [isAddMaterialModalOpen, setIsAddMaterialModalOpen] = useState(false);
  // const [isViewEnergyModalOpen, setIsViewEnergyModalOpen] = useState(false);
  // const [isAddEnergyModalOpen, setIsAddEnergyModalOpen] = useState(false);
  // const [isViewContractModalOpen, setIsViewContractModalOpen] = useState(false);
  // const [isAddContractModalOpen, setIsAddContractModalOpen] = useState(false);
  // const [isViewKeyModalOpen, setIsViewKeyModalOpen] = useState(false);
  // const [isAddKeyModalOpen, setIsAddKeyModalOpen] = useState(false);

  //const handleOpenViewMaterialModal = () => setIsViewMaterialModalOpen(true);
  //const handleCloseViewMaterialModal = () => setIsViewMaterialModalOpen(false);
  //const handleOpenAddMaterialModal = () => setIsAddMaterialModalOpen(true);
  //const handleCloseAddMaterialModal = () => setIsAddMaterialModalOpen(false);
  // const handleOpenViewEnergyModal = () => setIsViewEnergyModalOpen(true);
  // const handleCloseViewEnergyModal = () => setIsViewEnergyModalOpen(false);
  // const handleOpenAddEnergyModal = () => setIsAddEnergyModalOpen(true);
  // const handleCloseAddEnergyModal = () => setIsAddEnergyModalOpen(false);
  // const handleOpenViewContractModal = () => setIsViewContractModalOpen(true);
  // const handleCloseViewContractModal = () => setIsViewContractModalOpen(false);
  // const handleOpenAddContractModal = () => setIsAddContractModalOpen(true);
  // const handleCloseAddContractModal = () => setIsAddContractModalOpen(false);
  // const handleOpenViewKeyModal = () => setIsViewKeyModalOpen(true);
  // const handleCloseViewKeyModal = () => setIsViewKeyModalOpen(false);
  // const handleOpenAddKeyModal = () => setIsAddKeyModalOpen(true);
  // const handleCloseAddKeyModal = () => setIsAddKeyModalOpen(false);

  const handleIsVisibleInCalendarChange = async (value: boolean) => {
    if (value) {
      // Validate required fields before allowing publication
      const requiredFields = [
        'advertisedRentalPrice',
        'advertisedProvisions',
        'inspectionNumBedrooms', 
        'inspectionNumBathrooms',
        'unitCommercialDescription'
      ];
      
      const missingFields = requiredFields.filter(field => {
        const fieldValue = (unit as any)?.[field];
        return !fieldValue || (typeof fieldValue === 'string' && fieldValue.trim() === '');
      });
      
      if (missingFields.length > 0) {
        toast.error('Vul eerst alle verplichte velden in voordat u publiceert in de afsprakenkalender.');
        return; // Don't change the toggle
      }
      
      // Show confirmation modal when trying to publish
      setIsPublishModalOpen(true);
    } else {
      // Offline halen annuleert reeds geboekte bezoeken niet — die staan los van de
      // tijdsloten en de kandidaat krijgt geen verwittiging. Eerst waarschuwen.
      const visits = unit?.id ? await checkPlannedVisits(unit.id as string) : [];

      // visits === null: de controle faalde (toast getoond) — niet blokkeren.
      if (visits && visits.length > 0) {
        setPlannedVisitsForUnpublish(visits);
        return;
      }

      setEditedUnit((prev: any) => ({ ...prev, visibleInCalendar: false }));
    }
  };

  const handleConfirmUnpublish = () => {
    setPlannedVisitsForUnpublish(null);
    setEditedUnit((prev: any) => ({ ...prev, visibleInCalendar: false }));
  };

  const handleConfirmPublish = () => {
    setEditedUnit((prev: any) => ({ ...prev, visibleInCalendar: true }));
    setIsPublishModalOpen(false);
  };

  const handleCancelPublish = () => {
    setIsPublishModalOpen(false);
  };

  // Handle Unit ID Change
  const handleChangeUnitId = async (newUnitId: string) => {
    if (!unit?.id) return;

    setIsChangingId(true);
    try {
      const response = await fetchWithAuth(
        `${API_URL}/units/${unit.id}/change-id`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ newUnitId })
        },
        session
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Unit ID wijzigen mislukt');
      }

      const result: UnitIdChangeLog = await response.json();
      setChangeLog(result);
      setIsChangeIdModalOpen(false);
      setIsChangeLogViewerOpen(true);
      refreshResources();
      toast.success(`Unit ID succesvol gewijzigd naar ${newUnitId}`);
    } catch (error) {
      console.error('Error changing unit ID:', error);
      toast.error(error instanceof Error ? error.message : 'Unit ID wijzigen mislukt');
    } finally {
      setIsChangingId(false);
    }
  };

  const handleNavigateToNewUnit = () => {
    if (changeLog?.newUnitId) {
      setIsChangeLogViewerOpen(false);
      navigate(`/unit/detail/${changeLog.newUnitId}`);
      // Force reload to fetch new unit data
      window.location.reload();
    }
  };


  const resolvedUnitId = (unit?.id as string) || (unitId as string) || "";
  const resolvedBuildingId = (unit?.buildingId as string) || (buildingId as string) || "";

  const rentalStatus = (unit as any)?.rentalStatus as string | undefined;
  const rentalPrice = unit?.advertisedRentalPrice;
  const unitAddress = (unit as any)?.unitCustomAddress
    || (unit as any)?.building?.googlePlaceLongAddress
    || resolvedUnitId;

  return (
    <section>
      {/* Sticky summary header — always-visible unit identity + quick links */}
      {unit && (
        <div className="sticky top-0 z-20 mb-4 rounded-lg border border-neutral-primary/15 bg-white/95 p-3 shadow-sm backdrop-blur">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div className="flex min-w-0 flex-1 items-start gap-2">
              <Button
                variant="ghost"
                size="icon"
                onClick={() => navigate(-1)}
                aria-label="Terug"
                className="text-neutral-secondary-mid hover:text-brick-primary -mt-0.5 shrink-0"
              >
                <ArrowLeft size={18} weight="bold" />
              </Button>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-semibold text-neutral-primary">
                  {unitAddress}
                </p>
                <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-neutral-secondary-mid">
                  <span>Unit {resolvedUnitId}</span>
                  {unit.unitType && <span>· {unit.unitType}</span>}
                  {rentalStatus && (
                    <Badge variant="secondary" className="font-normal">
                      {rentalStatus}
                    </Badge>
                  )}
                  {rentalPrice != null && (
                    <span>· € {Number(rentalPrice).toFixed(0)} / maand</span>
                  )}
                </div>
              </div>
            </div>
            {resolvedUnitId && (
              <div className="flex flex-wrap items-center gap-2">
                <Button asChild variant="outline" size="sm">
                  <Link to={`/pictures/unit/${resolvedUnitId}`}>
                    <ImageSquare className="mr-2 h-4 w-4" weight="duotone" />
                    Foto's
                  </Link>
                </Button>
                <Button asChild variant="outline" size="sm">
                  <Link to={`/documents/unit/${resolvedUnitId}`}>
                    <FileText className="mr-2 h-4 w-4" weight="duotone" />
                    Documenten
                  </Link>
                </Button>
              </div>
            )}
          </div>
        </div>
      )}

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="flex h-auto w-full flex-wrap justify-start gap-2 bg-transparent p-0">
          <TabsTrigger
            value="overzicht"
            className="rounded-full px-3 py-1.5 text-sm font-medium text-neutral-primary hover:bg-neutral-primary/5 data-[state=active]:bg-brick-primary/10 data-[state=active]:text-brick-primary data-[state=active]:shadow-none data-[state=active]:font-semibold"
          >
            Overzicht
          </TabsTrigger>
          <TabsTrigger
            value="commercieel"
            className="rounded-full px-3 py-1.5 text-sm font-medium text-neutral-primary hover:bg-neutral-primary/5 data-[state=active]:bg-brick-primary/10 data-[state=active]:text-brick-primary data-[state=active]:shadow-none data-[state=active]:font-semibold"
          >
            Commerciële informatie
          </TabsTrigger>
          <TabsTrigger
            value="verhuur"
            className="rounded-full px-3 py-1.5 text-sm font-medium text-neutral-primary hover:bg-neutral-primary/5 data-[state=active]:bg-brick-primary/10 data-[state=active]:text-brick-primary data-[state=active]:shadow-none data-[state=active]:font-semibold"
          >
            Huurcontracten &amp; actuele huurders
          </TabsTrigger>
          <TabsTrigger
            value="kalender"
            className="rounded-full px-3 py-1.5 text-sm font-medium text-neutral-primary hover:bg-neutral-primary/5 data-[state=active]:bg-brick-primary/10 data-[state=active]:text-brick-primary data-[state=active]:shadow-none data-[state=active]:font-semibold"
          >
            Afsprakenkalender herverhuur
          </TabsTrigger>
          <TabsTrigger
            value="technisch"
            className="rounded-full px-3 py-1.5 text-sm font-medium text-neutral-primary hover:bg-neutral-primary/5 data-[state=active]:bg-brick-primary/10 data-[state=active]:text-brick-primary data-[state=active]:shadow-none data-[state=active]:font-semibold"
          >
            Technisch
          </TabsTrigger>
        </TabsList>

        {/* OVERZICHT — algemeen + kerncijfers + custom fields */}
        <TabsContent value="overzicht" className="mt-4">
          <div className="z-10 grid grid-cols-1 gap-8 rounded-lg bg-white p-4 shadow-md sm:grid-cols-2">
            <div>
              <RenderSectionComponent
                title="Algemeen"
                icon={<AlertInfo />}
                fieldsConfig={generalFieldsConfig as any[]}
                {...sharedSectionProps}
              />
              {canEditUnitIds && unit?.id && (
                <div className="mt-4 p-4 border border-neutral-primary/15 rounded-md bg-white">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm font-medium text-neutral-primary">Unit ID wijzigen</p>
                      <p className="text-xs text-neutral-primary/60">Alleen voor beheerders - wijzigt alle gerelateerde records</p>
                    </div>
                    <ButtonNew
                      label="Wijzig ID"
                      variant="secondaryNeutral"
                      icon={<PencilSimple size={16} />}
                      onClick={() => setIsChangeIdModalOpen(true)}
                    />
                  </div>
                </div>
              )}
            </div>
            <div>
              <RenderSectionComponent
                title="Kerncijfers"
                icon={<AlertInfo />}
                fieldsConfig={unitKeyFigures}
                {...sharedSectionProps}
              />
            </div>
            <div className="col-span-full" data-tour="custom-fields-section">
              {unit && (
                <CustomFieldsSection
                  scope="unit"
                  entityId={unit.id as string}
                  buildingId={unit.buildingId as string}
                />
              )}
            </div>
          </div>
        </TabsContent>

        {/* COMMERCIËLE INFORMATIE — publieke informatie, status, prijs, ruimte details, voorzieningen */}
        <TabsContent value="commercieel" className="mt-4">
          <div className="space-y-4">
            <div className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-moss-primary/20 bg-moss-primary/5 p-3 text-sm text-neutral-primary">
              <div className="flex items-center gap-2">
                <AlertInfo className="h-[18px] w-[18px]" />
                <span>
                  Dit is de informatie die gepubliceerd wordt op de afsprakenkalender.
                </span>
              </div>
              <button
                type="button"
                onClick={() => setActiveTab("kalender")}
                className="text-sm font-medium text-moss-primary hover:underline"
              >
                Ga naar Afsprakenkalender herverhuur →
              </button>
            </div>

            <div className="rounded-lg bg-white p-4 shadow-md">
              {unit && (
                <UnitCommercialInfoComponent
                  unit={unit}
                  onUnitUpdate={(updates) => {
                    setUnit(prev => prev ? { ...prev, ...updates } : null);
                    setEditedUnit(prev => prev ? { ...prev, ...updates } : null);
                  }}
                  isCompact={false}
                  onValidationErrors={(errors) => {
                    if (errors.length > 0) {
                      console.log('Validation errors:', errors);
                    }
                  }}
                  isPublishing={editedUnit?.visibleInCalendar || unit?.visibleInCalendar || false}
                />
              )}
            </div>

            {resolvedUnitId && (
              <UnitCommercialPicturesGrid unitId={resolvedUnitId} />
            )}
          </div>
        </TabsContent>

        {/* VERHUUR — contracts on this unit */}
        <TabsContent value="verhuur" className="mt-4">
          {resolvedUnitId && (
            <UnitRentalTab
              unitId={resolvedUnitId}
              buildingId={resolvedBuildingId}
            />
          )}
        </TabsContent>

        {/* AFSPRAKENKALENDER HERVERHUUR — publication settings + timeslots + yally.apartments link */}
        <TabsContent value="kalender" className="mt-4">
          <div className="rounded-lg bg-white p-4 shadow-md">
            <div className="mb-4 flex flex-wrap items-center justify-between gap-2 rounded-lg border border-moss-primary/20 bg-moss-primary/5 p-3 text-sm text-neutral-primary">
              <div className="flex items-center gap-2">
                <AlertInfo className="h-[18px] w-[18px]" />
                <span>
                  De commerciële informatie &amp; foto's die hier worden gepubliceerd, beheer je in het tabblad Commerciële informatie.
                </span>
              </div>
              <button
                type="button"
                onClick={() => setActiveTab("commercieel")}
                className="text-sm font-medium text-moss-primary hover:underline"
              >
                Ga naar Commerciële informatie →
              </button>
            </div>
            <div className="mb-4 flex flex-wrap items-center justify-between gap-2 rounded-md border border-neutral-primary/15 bg-neutral-primary/5 p-3">
              <div className="min-w-0">
                <p className="text-sm font-medium text-neutral-primary">
                  Publieke herverhuurpagina
                </p>
                <p className="text-xs text-neutral-secondary-mid">
                  Zo ziet deze unit er op yally.apartments uit voor kandidaten.
                </p>
              </div>
              <Button asChild variant="outline" size="sm">
                <a
                  href="https://yally.apartments"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open yally.apartments
                  <ArrowSquareOut className="ml-2 h-4 w-4" weight="bold" />
                </a>
              </Button>
            </div>
            <div className="mb-4 divide-y divide-neutral-primary/15 rounded-md border border-neutral-primary/15 bg-white">
              <SectionHeader
                title={"Publieke kalender instellingen"}
                icon={<Eye />}
                editMode={editMode}
                onEditClick={toggleEditMode}
                onSaveClick={saveUnitUpdates}
                showEditToggle={true}
              />
              <div
                className={`bg-primary-moss font-bold !important flex flex-wrap items-center justify-between p-2.5 text-sm`}
              >
                <span>Staat gepubliceerd in afsprakenkalender</span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={
                      editedUnit?.visibleInCalendar !== undefined
                        ? editedUnit.visibleInCalendar
                        : unit?.visibleInCalendar || false
                    }
                    onChange={(e) => handleIsVisibleInCalendarChange(e.target.checked)}
                    disabled={!editMode}
                    className="sr-only peer"
                  />
                  <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-hidden peer-focus:ring-4 peer-focus:ring-moss-primary/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-moss-primary peer-disabled:opacity-50 peer-disabled:cursor-not-allowed"></div>
                </label>
              </div>
              <div className="p-4">
                <ImprovedTimeslotManager unitId={unit?.id as string} />
              </div>
            </div>
          </div>
        </TabsContent>

        {/* TECHNISCH — utilities, assets, Yally standards, EPC, QR */}
        <TabsContent value="technisch" className="mt-4">
          <div className="grid grid-cols-1 gap-8 rounded-lg bg-white p-4 shadow-md sm:grid-cols-2">
            <div>
              <RenderSectionComponent
                title="Technische voorzieningen"
                icon={<AlertInfo />}
                fieldsConfig={utilitiesConfig}
                {...sharedSectionProps}
              />
            </div>
            <div>
              <RenderSectionComponent
                title="Yally standards"
                icon={<New />}
                fieldsConfig={yallyStandardsFieldsConfig}
                {...sharedSectionProps}
              />
              <div className="mt-4 divide-y divide-neutral-primary/15 rounded-md border border-neutral-primary/15 bg-white">
                <div className="flex items-center justify-between gap-2 rounded-md px-2.5 py-2.5">
                  <div className="flex flex-row items-center gap-1.5">
                    <QRCode className="h-[18px] w-[18px]" />
                    <p className="text-lg">QR code</p>
                  </div>
                </div>
              </div>
            </div>
            {unit && (
              <div className="col-span-full flex flex-col gap-3">
                <BuildingAssetsTab
                  buildingId={unit.buildingId as string}
                  unitId={unit.id as string}
                />
              </div>
            )}
            {unit && (
              <div className="col-span-full flex flex-col gap-3">
                <header className="flex justify-between">
                  <div className="flex items-center gap-2">
                    <AlertInfo className="h-[18px] w-[18px]" />
                    <p className="text-lg">EPC</p>
                  </div>
                  <Link to="unit/new">
                    <ButtonNew
                      icon={<Plus />}
                      label="EPC toevoegen"
                      variant="primaryMoss"
                    />
                  </Link>
                </header>
              </div>
            )}
          </div>
        </TabsContent>
      </Tabs>
        {/* <div key="inspections" className="col-span-full flex flex-col gap-3">
          <header className="flex justify-between">
            <div className="flex items-center gap-2">
              <MagnifyingGlassPlus weight="duotone" size={18} />
              <p className="text-lg">Keuringen</p>
            </div>
            <ButtonNew
              // onClick={handleOpenAddKeyModal}
              icon={<Plus />}
              label="Dummy button"
              variant="primaryMoss"
            />
          </header>
          <Table
            aria-label="Service Table"
            color="success"
            classNames={{
              wrapper: "shadow-none rounded-none p-0",
              thead: "h-fit border-b-2 border-neutral-primary/40",
              th: "rounded-none! bg-white py-2 h-fit text-sm text-neutral-primary font-medium",
              tbody: "border-b divide-y divide-neutral-primary/15",
              tr: "divide-x divide-neutral-primary/15",
              td: "py-2.5",
            }}
          >
            <TableHeader>
              <TableColumn key="name">Naam</TableColumn>
              <TableColumn key="status">Status</TableColumn>
              <TableColumn key="nextInspection">Volgende keuring</TableColumn>
              <TableColumn key="documents">Documenten</TableColumn>
              <TableColumn key="actions">Acties</TableColumn>
            </TableHeader>
            <TableBody emptyContent={<p>No rows to display.</p>}>
              {dummyInspectionData.map((item) => (
                <TableRow key={item.name}>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.status}</TableCell>
                  <TableCell>{item.nextInspection}</TableCell>
                  <TableCell>
                    <Tooltip content="Bekijk documenten">
                      <a href="#">
                        <FileText size={22} weight="duotone" />
                      </a>
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center gap-2">
                      <Tooltip content="Bekijk details">
                        <a
                          href="javascript:void(0);"
                          // onClick={handleOpenDetailModal}
                        >
                          <Eye size={22} weight="duotone" />
                        </a>
                      </Tooltip>
                      <Tooltip content="Verwijder service">
                        <a href="#">
                          <Trash
                            size={22}
                            weight="duotone"
                            className="text-status-bad"
                          />
                        </a>
                      </Tooltip>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div> */}

      {/* <ModalViewEnergy
        isOpen={isViewEnergyModalOpen}
        onClose={handleCloseViewEnergyModal}
      />
      <ModalViewKey
        isOpen={isViewKeyModalOpen}
        onClose={handleCloseViewKeyModal}
      /> */}
      {/* <ModalViewContract
        isOpen={isViewContractModalOpen}
        onClose={handleCloseViewContractModal}
      /> */}
      {/* <ModalAddEnergy
        isOpen={isAddEnergyModalOpen}
        onClose={handleCloseAddEnergyModal}
      /> */}
      {/* <ModalAddKey
        isOpen={isAddKeyModalOpen}
        onClose={handleCloseAddKeyModal}
      /> */}
      {/* <ModalAddContract
        isOpen={isAddContractModalOpen}
        onClose={handleCloseAddContractModal}
      /> */}

      <PublishCalendarModal
        isOpen={isPublishModalOpen}
        onClose={handleCancelPublish}
        onConfirm={handleConfirmPublish}
        availableFrom={unit?.availableFrom}
        rentalPrice={unit?.advertisedRentalPrice}
        provisions={unit?.advertisedProvisions}
      />

      <PlannedVisitsWarningModal
        isOpen={!!plannedVisitsForUnpublish}
        visits={plannedVisitsForUnpublish ?? []}
        action="unpublish"
        onCancel={() => setPlannedVisitsForUnpublish(null)}
        onConfirm={handleConfirmUnpublish}
      />

      {/* Change Unit ID Modal */}
      <ChangeUnitIdModal
        isOpen={isChangeIdModalOpen}
        onClose={() => setIsChangeIdModalOpen(false)}
        onConfirm={handleChangeUnitId}
        currentUnitId={unit?.id || ''}
        buildingId={unit?.buildingId || buildingId || ''}
        isLoading={isChangingId}
      />

      {/* Change Log Viewer Modal */}
      <ChangeLogViewer
        isOpen={isChangeLogViewerOpen}
        onClose={() => setIsChangeLogViewerOpen(false)}
        changeLog={changeLog}
        onNavigateToNewUnit={handleNavigateToNewUnit}
      />
    </section>
  );
};
